@let comparableSales = comparableSales$ | async; @let mapOptions = mapOptions$ | async;

<red-header-content>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="{{defaultBackHref}}/profile/{{profileId}}/sale-information"></ion-back-button>
    </ion-buttons>
    <ion-title>Comparable Sales</ion-title>
  </ion-toolbar>
  <ion-toolbar>
    <ion-segment (ionChange)="segmentChange($event)" [value]="selectedTab">
      <ion-segment-button value="list">
        <ion-label>List View</ion-label>
      </ion-segment-button>
      <ion-segment-button value="map">
        <ion-label>Map View</ion-label>
      </ion-segment-button>
    </ion-segment>
  </ion-toolbar>
</red-header-content>
@switch (selectedTab) { @case ('map') {
<ion-content color="light">
  @if (mapOptions) { @let comparableSalesMarkerOptions = comparableSalesMarkerOptions$ | async;
  <google-map height="100%" width="100%" [options]="mapOptions" (mapInitialized)="mapInitialized($event)">
    <red-user-position></red-user-position>
    @let mapCenter = mapCenter$ | async; @if (mapCenter) { @let markerOptions = markerOptions$ | async; @if
    (markerOptions) {
    <map-marker [position]="mapCenter" [options]="markerOptions"> </map-marker>
    } @else {
    <map-marker [position]="mapCenter"></map-marker>
    } } @for (comparableSale of comparableSales; track comparableSale) { @if (comparableSalesMarkerOptions) {
    <map-marker
      [position]="comparableSale.location"
      [options]="comparableSalesMarkerOptions"
      (mapClick)="selectComparableSaleMarker(comparableSale)"
    ></map-marker>
    } @else {
    <map-marker
      [position]="comparableSale.location"
      (mapClick)="selectComparableSaleMarker(comparableSale)"
    ></map-marker>
    } }
  </google-map>
  }
  <div class="tw:absolute tw:top-0 tw:w-full">
    <red-map-default-options>
      <ion-fab-button (click)="centerOnBounds()" color="light" size="small">
        <ion-icon src="/assets/svg/target.svg"></ion-icon>
      </ion-fab-button>
    </red-map-default-options>
  </div>
  <div class="tw:absolute tw:right-1/2 tw:bottom-0 tw:w-full tw:max-w-2xl tw:translate-x-1/2">
    @if (selectedComparableSale) {
    <ion-card color="light">
      <ion-card-header class="tw:pb-0">
        <ion-card-subtitle>Selected PIN at:</ion-card-subtitle>
      </ion-card-header>
      <ion-card-content>
        <div class="tw:flex tw:justify-between tw:align-middle">
          <div class="tw:pr-1">
            <div class="tw:text-sm">
              <ion-text>{{selectedComparableSale | redAddress:addressType.LineOne}}</ion-text>
            </div>
            <div class="tw:text-xs">
              <ion-text color="medium">{{selectedComparableSale | redAddress:addressType.LineTwo}}</ion-text>
            </div>
          </div>
          <div class="tw:flex tw:flex-col tw:items-center tw:align-middle">
            <ion-button
              (click)="loadProfile(selectedComparableSale)"
              class="tw:whitespace-nowrap"
              size="small"
              fill="solid"
            >
              <ion-icon slot="end" name="chevron-forward-circle-outline"></ion-icon>Profile</ion-button
            >
            <ion-button (click)="clearSearch()" class="tw:whitespace-nowrap" size="small" fill="clear" color="danger">
              <ion-icon slot="end" name="close-circle-outline"></ion-icon>
              Cancel
            </ion-button>
          </div>
        </div>
      </ion-card-content>
    </ion-card>
    }
  </div>
</ion-content>
} @default {
<red-page-content [paddingBottom]="true">
  @for (comparableSale of comparableSales; track comparableSale) {
  <ion-list [inset]="true" lines="full" class="no-last-line">
    <ion-item-divider>
      <ion-label>{{comparableSale.data.RecordingDate | date:'MM/dd/yyyy'}}</ion-label>
    </ion-item-divider>
    <ion-item [detail]="false">
      <ion-label>
        <div class="tw:flex tw:justify-between">
          <div>
            <ion-text class="tw:text-sm tw:font-bold" color="medium">
              {{comparableSale | redAddress:addressType.LineOneAndCity}}
            </ion-text>
          </div>
          <div>
            <ion-button (click)="loadProfile(comparableSale)" class="tw:whitespace-nowrap" size="small" fill="solid">
              <ion-icon slot="end" name="chevron-forward-circle-outline"></ion-icon>Profile</ion-button
            >
          </div>
        </div>
        <ion-text class="tw:text-lg tw:font-bold">{{comparableSale.data.SalePrice | redCurrency}}</ion-text>
      </ion-label>
    </ion-item>
    <ion-item>
      <ion-label>{{comparableSale.data.PricePerSQFT | redCurrency}} / Sq Ft</ion-label>
    </ion-item>
    <ion-item>
      <ion-icon color="medium" slot="start" src="/assets/svg/bedroom.svg"></ion-icon>
      <ion-label> Bedrooms </ion-label>
      <ion-note slot="end">{{comparableSale.data.Bedrooms | redDashIfEmpty}}</ion-note>
    </ion-item>
    <ion-item>
      <ion-icon color="medium" slot="start" src="/assets/svg/bathroom.svg"></ion-icon>
      <ion-label> Bathrooms </ion-label>
      <ion-note slot="end">{{comparableSale.data.Baths | redDashIfEmpty}}</ion-note>
    </ion-item>
    <ion-item>
      <ion-label> Building Area </ion-label>
      <ion-note slot="end">{{comparableSale.data.bldgSize | redSurface}}</ion-note>
    </ion-item>
    <ion-item>
      <ion-label> Lot Size </ion-label>
      <ion-note slot="end">{{comparableSale.data.lotSize | redSurface}}</ion-note>
    </ion-item>
  </ion-list>
  }
</red-page-content>
} }
